import React from 'react';
import { Button } from '../../../../../Utility/Button';
import useGlobals from '../../../../../../Hooks/useGlobals';

interface TestControlsProps {
    selectedEndpoint: any;
    isTesting: boolean;
    testResult: any;
    onExecuteTest: () => void;
    onClearResults: () => void;
}

const TestControls: React.FC<TestControlsProps> = ({
    selectedEndpoint,
    isTesting,
    testResult,
    onExecuteTest,
    onClearResults,
}) => {
    const { i18n } = useGlobals();

    return (
        <div className="mt-0 flex items-center gap-3">
            <Button
                onClick={onExecuteTest}
                disabled={!selectedEndpoint || isTesting}
                className="flex items-center gap-2"
            >
                {!testResult ? i18n.translate({ id: 'testing.execute', sourceName: 'OpenAPI' }) : 'Erneut testen'}
            </Button>

            {testResult && (
                <Button variant="secondary" onClick={onClearResults} className="flex items-center gap-2">
                    {i18n.translate({ id: 'testing.clear', sourceName: 'OpenAPI' })}
                </Button>
            )}
        </div>
    );
};

export default TestControls;
